import * as ep from "./endpoints";
import api from "@/libs/axios";

import main from "./pages/main/store";
import activites_ from "./pages/general-activities/store";
import ngos from "./pages/ngo-main/store";
import contact_us from "./pages/contact-us/store";
import donation from "./pages/platform-donation/store";
import donationNgo from "./pages/donation/store";
import ngoList from "./pages/ngo-list/store";
import NgoMap from "./pages/ngos-map/store";
import AboutMinistry from "./pages/about-ministry/store";
import jobs from "./pages/jobs/store";
import faq from "./pages/FAQ/store";
import volunteer from "./pages/volunteer/store";
import jobInfo from "./pages/jobs-info/store";
import newsNgo from "./pages/news/store";
import Signup from "./pages/signup/store";
import Founders from "./pages/founders/store";
import Circulars from "./pages/legal-references/circulars/store";
import Decisions from "./pages/legal-references/decisions/store";
import Systems from "./pages/legal-references/system/store";
import Laws from "./pages/legal-references/laws/store";
import NgoRelatedLaws from "./pages/legal-references/decrees/store";
import Assest from "./pages/assest-pages/store";
import RegulationView from "./pages/legal-references/regulation-view/store";

export default {
  namespaced: true,
  modules: {
    Assest,
    NgoMap,
    main,
    activites_,
    ngos,
    contact_us,
    donation,
    donationNgo,
    ngoList,
    jobs,
    AboutMinistry,
    faq,
    volunteer,
    jobInfo,
    newsNgo,
    Signup,
    Founders,
    Circulars,
    Decisions,
    Systems,
    Laws,
    NgoRelatedLaws,
    RegulationView,
  },
  state: {
    logo: "",
  },
  getters: {
    logo(state) {
      return state.logo;
    },
  },
  mutations: {
    setLogo(state, payload) {
      state.logo = payload;
    },
  },
  actions: {
    getLogo(context, payload) {
      api.get(ep.LOGO(payload.id)).then((res) => {
        context.commit("setLogo", res.data.data);
      });
    },
  },
};
